import React from 'react';

import { MessagesProvider, Message } from '../Internationalization/index';

import messages from '../NewsletterForm/messages';

const NewsletterInvitation = () => (
  <MessagesProvider messages={messages}>
    <React.Fragment>
      <h2 className="h5 font-family-clearface text-black text-color-white mb-small">
        <Message id="title" />
      </h2>
      <small className="text-color-white">
        <Message id="description" />
      </small>
    </React.Fragment>
  </MessagesProvider>
);

export default NewsletterInvitation;



// WEBPACK FOOTER //
// ./src/modules/NewsletterInvitation/index.js